var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var MiniPlaceholder = /** @class */ (function (_super) {
    __extends(MiniPlaceholder, _super);
    function MiniPlaceholder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MiniPlaceholder.prototype.renderItems = function (eventsCount) {
        var elements = [];
        for (var i = 1; i <= eventsCount; i++) {
            elements.push(React.createElement("div", { key: "mini-placeholder_item_" + i, className: "rj-mini-ev-card__placeholder__card-items-wrap" },
                React.createElement("div", { className: "rj-mini-ev-card__placeholder__player-info" },
                    React.createElement("div", { className: "rj-mini-ev-card__placeholder__player-names-wrap" },
                        React.createElement("div", { className: "rj-mini-ev-card__placeholder__player-name" }),
                        React.createElement("div", { className: "rj-mini-ev-card__placeholder__player-name" })),
                    React.createElement("div", { className: "rj-mini-ev-card__placeholder__card-item-icon" }))));
        }
        return elements;
    };
    MiniPlaceholder.prototype.render = function () {
        return (React.createElement("div", { className: "rj-mini-ev-card__placeholder" }, this.renderItems(this.props.eventsCount)));
    };
    return MiniPlaceholder;
}(React.PureComponent));
export { MiniPlaceholder };
//# sourceMappingURL=MiniPlacehoder.js.map